import { axiosPost, axiosGet } from "../react_axios/Axios"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// export const BASE_URL = "http://localhost:9000";
// export const BASE_URL = "https://tradedesk.india-itme.com/api";
// export const BASE_URL = "https://tradedesk_uat.india-itme.com/api";

//dev urls..............................................
// export const BASE_URL = "http://192.168.3.11:9305/api";
// export var link_BASE_URL = `http://192.168.3.11:9305/#/`;
// export const DOC_BASE_URL = "http://192.168.3.11:9305";
// export var REPORT_BASE_URL = `http://192.168.3.11:9305/doc`;
//..............................................................

//PROD & UAT urls..............................................
export const BASE_URL = `https://${window.location.host}/api`;
export var link_BASE_URL = `https://${window.location.host}/#/`;
export const DOC_BASE_URL = `https://${window.location.host}`;
export var REPORT_BASE_URL = `https://${window.location.host}/doc`;
//...............................................................



// prod url with HTTaPS.....................................................
// export var BASE_URL = `https://${window.location.host}/api`;
// prod url with HTTP only.....................................................
// export var BASE_URL = `http://${window.location.host}/api`;


// link for Download submitted undertaking for uat
export const sessionExpireMessage = "Session expired! Please login again.";
export const tokenInavlidMessage = "Token invalid";

export const fetchAuthReport = `${REPORT_BASE_URL}/report/SetParameterData`;
export const downloadReport = `${REPORT_BASE_URL}/WebForm/ItmeReportViewer.aspx`;
export const registrationReportName = `RegistrationDetails.rpt`;
export const registrationPreviewName = `RegistrationPreview.rpt`;
export const proformaInvoiceRpt = `ProformaInvoice.rpt`;
export const ReceiptRpt = `ReceiptVoucher.rpt`;
export const taxInvoiceRpt = `TaxInvoice.rpt`;


// auth
export const loginUserUrl = `${BASE_URL}/auth/loginUser`;
// export const changePasswordUrl = `${BASE_URL}/auth/changePassword`;
export const updatePasswordUrl = `${BASE_URL}/auth/updatePassword`;
export const getCredentialUrl = `${BASE_URL}/auth/getCredential`;
// // forget login password
export const forgetPasswordUrl = `${BASE_URL}/auth/forgetPassword`;
export const forgetGetOtpUrl = `${BASE_URL}/auth/forgetGetOtp`;
export const verifyOtpUrl = `${BASE_URL}/auth/verifyOtp`;
export const forgetUpdatePasswordUrl = `${BASE_URL}/auth/forgetUpdatePassword`;

// dropdown list
export const fillListUrl = `${BASE_URL}/fillList/getDropdownList`;

//registration
export const insertMemberRegistrationUrl = `${BASE_URL}/registration/insertMemberRegistration`;
export const updateMemberRegistrationUrl = `${BASE_URL}/registration/updateMemberRegistration`;
export const getMemberBuisnessRegistrationUrl = `${BASE_URL}/registration/getMemberBuisnessRegistration`;
export const getMemberRegistrationUrl = `${BASE_URL}/registration/getMemberRegistration`;
export const getIncompleteMemberRegistrationUrl = `${BASE_URL}/registration/getIncompleteMemberRegistration`;
export const getIncompleteMemberBuisnessRegistrationUrl = `${BASE_URL}/registration/getIncompleteMemberBuisnessRegistration`;
export const getMemberPaymentDetailsUrl = `${BASE_URL}/registration/getMemberPaymentDetails`;
export const deleteRegistrationDocumentUrl = `${BASE_URL}/registration/deleteRegistrationDocument`;
export const checkAvailableUsernameUrl = `${BASE_URL}/registration/checkAvailableUsername`;
export const insertUpdatePaymentUrl = `${BASE_URL}/registration/insertUpdatePayment`;
//enquiry
export const getEnquiryRegDetailsUrl = `${BASE_URL}/enquiry/getEnquiryRegDetails`;
export const getEnquiryListUrl = `${BASE_URL}/enquiry/getEnquiryList`;
export const insertEnquiryUrl = `${BASE_URL}/enquiry/insertEnquiry`;
export const getEnquiryDetailsUrl = `${BASE_URL}/enquiry/getEnquiryDetails`;

//user Section
export const getMemberDashboardCardsUrl = `${BASE_URL}/memberDashboard/getMemberDashboardCards`;

//admin
//user
export const getUserListUrl = `${BASE_URL}/admin-user/getUserList`;
export const getUserListExportUrl = `${BASE_URL}/admin-user/getUserListExport`;
export const userDetailsUrl = `${BASE_URL}/admin-user/userDetails`;
export const shareCredentialUrl = `${BASE_URL}/admin-user/shareCredential`;
export const updateMemberDetailsUrl = `${BASE_URL}/admin-user/updateMemberDetails`;
//proforma
export const getProformaListUrl = `${BASE_URL}/proforma/getProformaList`;
export const shareProformaUrl = `${BASE_URL}/proforma/shareProforma`;
//tax invoice
export const getTaxInvoiceListUrl = `${BASE_URL}/taxInvoice/getTaxInvoiceList`;
export const shareTaxInvoiceUrl = `${BASE_URL}/taxInvoice/shareTaxInvoice`;
//benefits
export const getBenefitListUrl = `${BASE_URL}/benefits/getBenefitList`;

// receipt
export const fetchReceiptListUrl = `${BASE_URL}/receipt/fetchReceiptList`;

// static
export const countDownDateUrl = `${BASE_URL}/static/countDownDate`;
export const getWebsiteBlogListUrl = `${BASE_URL}/static/getWebsiteBlogList`;
export const getWebsiteBlogDetailsUrl = `${BASE_URL}/static/getWebsiteBlogDetails`;
export const getStaticMemberListUrl = `${BASE_URL}/static/getStaticMemberList`;

//role
export const getRoleListUrl = `${BASE_URL}/role/getRoleList`;
export const getRoleDetailsUrl = `${BASE_URL}/role/getRoleDetails`;
export const insertUpdateRoleUrl = `${BASE_URL}/role/insertUpdateRole`;
export const deleteRoleUrl = `${BASE_URL}/role/deleteRole`;


//pg
export const sendPaymentFormUrl = `${BASE_URL}/payment/sendSmartPaymentForm`;

//receipt
export const receiptUpdateUrl = `${BASE_URL}/receipt/updateReceipt`;
export const receiptListUrl = `${BASE_URL}/receipt/fetchReceiptList`;
export const proformaInvoiceUrl = `${BASE_URL}/receipt/getProformaInvoice`;
export const receiptDetailsUrl = `${BASE_URL}/receipt/getReceiptDetails`;
export const generateVoucherUrl = `${BASE_URL}/receipt/generateVoucher`;
export const receiptAddUrl = `${BASE_URL}/receipt/addReceipt`;
export const shareEmailUrl = `${BASE_URL}/receipt/shareEmail`;
export const receiptNoUrl = `${BASE_URL}/receipt/getReceiptNo`;
export const receiptSaveUrl = `${BASE_URL}/receipt/addReceipt`;
export const getEmailDataUrl = `${BASE_URL}/receipt/getEmailData`;
export const receiptDelUrl = `${BASE_URL}/receipt/delReceipt`;
export const getPendingReceiptDetailsUrl = `${BASE_URL}/receipt/getpendingreceipt`;
export const receiptShareUrl = `${BASE_URL}/receipt/receiptShare`;

// cart
export const getCartListUrl = `${BASE_URL}/cart/getCartList`;

//promo code
export const getPromoCodeListUrl = `${BASE_URL}/promoCode/getPromoCodeList`;
export const getPromoCodeDetailsUrl = `${BASE_URL}/promoCode/getPromoCodeDetails`;
export const insertPromoCodeUrl = `${BASE_URL}/promoCode/insertPromoCode`;
export const updatePromoCodeUrl = `${BASE_URL}/promoCode/updatePromoCode`;
export const deletePromoCodeUrl = `${BASE_URL}/promoCode/deletePromoCode`;

// Blog
export const getBlogListUrl = `${BASE_URL}/blog/getBlogList`;
export const getBlogDetailsUrl = `${BASE_URL}/blog/getBlogDetails`;
export const insertUpdateBlogUrl = `${BASE_URL}/blog/insertUpdateBlog`;
export const deleteBlogUrl = `${BASE_URL}/blog/deleteBlog`;
// reports
export const getReportListUrl = `${BASE_URL}/reports/getReportList`;
export const reportDetailListUrl = `${BASE_URL}/reports/reportDetailList`;
export const getDynamicReportUrl = `${BASE_URL}/reports/getDynamicReport`;
export const getDynamicFillListUrl = `${BASE_URL}/reports/getDynamicFillList`;
//master
export const getMasterListUrl = `${BASE_URL}/master/getMasterList`;
export const getMasterDetailsUrl = `${BASE_URL}/master/getMasterDetails`;
export const insertUpdateMasterUrl = `${BASE_URL}/master/insertUpdateMaster`;
export const deleteMasterUrl = `${BASE_URL}/master/deleteMaster`;

//cms
export const getCmsContentUrl = `${BASE_URL}/cms/getCmsContent`
export const IUCmsContentUrl = `${BASE_URL}/cms/insertUpdateCMSContent`
export const IUCmsContentSectionUrl = `${BASE_URL}/cms/insertUpdateCMSContentSection`
export const IUCmsMenuUrl = `${BASE_URL}/cms/insertUpdateCMSMenu`
export const IUCmsFooterUrl = `${BASE_URL}/cms/insertUpdateCMSFooter`
export const IUCmsBannerUrl = `${BASE_URL}/cms/insertUpdateCMSBanner`
export const IUCmsSubheaderUrl = `${BASE_URL}/cms/insertUpdateCMSSubheader`
export const PublishCmsContentUrl = `${BASE_URL}/cms/publishCMSContent`
export const PublishCmsMenuUrl = `${BASE_URL}/cms/publishCMSMenu`
export const PublishCmsFooterUrl = `${BASE_URL}/cms/publishCMSFooter`
export const PublishCmsBannerUrl = `${BASE_URL}/cms/publishCMSBanner`
export const PublishCmsSubheaderUrl = `${BASE_URL}/cms/publishCMSSubheader`
export const updateCMSContentStatusUrl = `${BASE_URL}/cms/updateCMSContentStatus`
export const deleteCMSMenuUrl = `${BASE_URL}/cms/deleteCMSMenu`
export const deleteCMSStaticFilesUrl = `${BASE_URL}/cms/deleteCMSStaticFiles`
export const insertUpdateCMSStaticUploadsUrl = `${BASE_URL}/cms/insertUpdateCMSStaticUploads`


//cms
export const GET_CMS_CONTENT_ACTION_TYPE = "GET_CMS_CONTENT_ACTION_TYPE"
export const IU_CMS_CONTENT_ACTION_TYPE = "IU_CMS_CONTENT_ACTION_TYPE"
export const IU_CMS_CONTENT_SECTION_ACTION_TYPE = "IU_CMS_CONTENT_SECTION_ACTION_TYPE"
export const IU_CMS_MENU_ACTION_TYPE = "IU_CMS_MENU_ACTION_TYPE"
export const IU_CMS_FOOTER_ACTION_TYPE = "IU_CMS_FOOTER_ACTION_TYPE"
export const IU_CMS_BANNER_ACTION_TYPE = "IU_CMS_BANNER_ACTION_TYPE"
export const IU_CMS_SUBHEADER_ACTION_TYPE = "IU_CMS_SUBHEADER_ACTION_TYPE"
export const PUBLISH_CMS_CONTENT_ACTION_TYPE = "PUBLISH_CMS_CONTENT_ACTION_TYPE"
export const PUBLISH_CMS_MENU_ACTION_TYPE = "PUBLISH_CMS_MENU_ACTION_TYPE"
export const PUBLISH_CMS_FOOTER_ACTION_TYPE = "PUBLISH_CMS_FOOTER_ACTION_TYPE"
export const PUBLISH_CMS_BANNER_ACTION_TYPE = "PUBLISH_CMS_BANNER_ACTION_TYPE"
export const PUBLISH_CMS_SUBHEADER_ACTION_TYPE = "PUBLISH_CMS_SUBHEADER_ACTION_TYPE"
export const UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE = "UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE"
export const DELETE_CMS_MENU_ACTION_TYPE = "DELETE_CMS_MENU_ACTION_TYPE"
export const DELETE_CMS_STATIC_FILES_ACTION_TYPE = "DELETE_CMS_STATIC_FILES_ACTION_TYPE"
export const IU_CMS_STATIC_UPLOADS_ACTION_TYPE = "IU_CMS_STATIC_UPLOADS_ACTION_TYPE"

//event master
export const getEventMasterListUrl = `${BASE_URL}/event/getEventMasterList`;
export const getEventMasterDetailsUrl = `${BASE_URL}/event/getEventMasterDetails`;
export const insertUpdateEventMasterUrl = `${BASE_URL}/event/insertUpdateEventMaster`;
export const deleteEventMasterUrl = `${BASE_URL}/event/deleteEventMaster`;


//event enquiry
export const getEventEnquiryListUrl = `${BASE_URL}/eventEnquiry/getEventEnquiryList`;
export const getEventEnquiryDetailsUrl = `${BASE_URL}/eventEnquiry/getEventEnquiryDetails`;
export const insertUpdateEventEnquiryUrl = `${BASE_URL}/eventEnquiry/insertUpdateEventEnquiryUrl`;
export const deleteEventEnquiryUrl = `${BASE_URL}/eventEnquiry/deleteEventEnquiry`;


export const headers = {
  'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
  'Content-Type': 'application/json',
}

//action type start.....................

export const FILL_LIST_ACTION_TYPE = "FILL_LIST_ACTION_TYPE";

export const INSERT_MEMBER_REGISTRATION = "INSERT_MEMBER_REGISTRATION";
export const UPDATE_MEMBER_REGISTRATION = "UPDATE_MEMBER_REGISTRATION";
export const GET_MEMBER_REGISTRATION = "GET_MEMBER_REGISTRATION";
export const GET_MEMBER_BUISNESS_REGISTRATION = "GET_MEMBER_BUISNESS_REGISTRATION";
export const GET_INCOMPLETE_MEMBER_REGISTRATION = "GET_INCOMPLETE_MEMBER_REGISTRATION";
export const GET_INCOMPLETE_MEMBER_BUISNESS_REGISTRATION = "GET_INCOMPLETE_MEMBER_BUISNESS_REGISTRATION";
export const GET_MEMBER_PAYMENT_DETAILS = "GET_MEMBER_PAYMENT_DETAILS";
export const REGISTRATION_PREVIEW = "REGISTRATION_PREVIEW";
export const DELETE_REGISTRATION_DOCUMENT = "DELETE_REGISTRATION_DOCUMENT";
export const CHECK_AVAILABLE_USERNAME = "CHECK_AVAILABLE_USERNAME";
export const INSERT_UPDATE_PAYMENT = "INSERT_UPDATE_PAYMENT";
//enquiry
export const GET_ENQUIRY_REG_DETAILS_ACTION = "GET_ENQUIRY_REG_DETAILS"
export const GET_ENQUIRY_LIST_ACTION = "GET_ENQUIRY_LIST"
export const INSERT_ENQUIRY_ACTION = "INSERT_ENQUIRY"
export const GET_ENQUIRY_DETAILS = "GET_ENQUIRY_DETAILS"
//Reports
export const GET_REPORT_DETAIL = "GET_REPORT_DETAIL";
export const GET_REPORT_LIST = "GET_REPORT_LIST";
export const GET_DYNAMIC_REPORT = "GET_DYNAMIC_REPORT";
export const GET_DYNAMIC_FILLLIST = "GET_DYNAMIC_FILLLIST";
//admin
//user
export const GET_USER_LIST_ACTION = "GET_USER_LIST";
export const GET_USER_LIST_EXPORT_ACTION = "GET_USER_LIST_EXPORT";
export const GET_USER_DETAILS_ACTION = "GET_USER_DETAILS";
export const GET_USER_REGISTRATION_RPT_ACTION_TYPE = "GET_USER_REGISTRATION_RPT_ACTION_TYPE"
export const SHARE_CREDENTIAL_ACTION = "SHARE_CREDENTIAL";
export const UPDATE_MEMBER_DETAILS_ACTION = "UPDATE_MEMBER_DETAILS";
//proforma
export const GET_PROFORMA_RPT_ACTION_TYPE = "GET_PROFORMA_RPT_ACTION_TYPE"
export const GET_PROFORMA_LIST_ACTION = "GET_PROFORMA_LIST";
export const SHARE_PROFORMA_ACTION = "SHARE_PROFORMA";
//tax invoice
export const GET_INVOICE_RPT_ACTION_TYPE = "GET_INVOICE_RPT_ACTION_TYPE"
export const GET_TAXINVOICE_LIST_ACTION = "GET_TAXINVOICE_LIST";
export const SHARE_TAXINVOICE_ACTION = "SHARE_TAXINVOICE";

//benefit
export const GET_BENEFIT_LIST_ACTION = "GET_BENEFIT_LIST";

// receipt
export const FETCH_RECEIPT_LIST = "FETCH_RECEIPT_LIST";

// static
export const COUNT_DOWN_DATE_ACTION = "COUNT_DOWN_DATE_ACTION";
export const GET_WEBSITE_BLOG_LIST_ACTION = "GET_WEBSITE_BLOG_LIST_ACTION";
export const GET_STATIC_MEMBER_LIST_ACTION = "GET_STATIC_MEMBER_LIST_ACTION";

//role
export const ROLE_LIST_ACTION = "ROLE_LIST_ACTION";
export const ROLE_DETAIL_ACTION = "ROLE_DETAIL_ACTION";
export const INSERT_UPDATE_ROLE_ACTION = "INSERT_UPDATE_ROLE_ACTION";
export const DELETE_ROLE_ACTION = "DELETE_ROLE_ACTION";

// login
export const LOGIN_ACTION_TYPE = "LOGIN";
// export const CHANGE_PASSWORD_ACTION_TYPE = "CHANGE_PASSWORD_ACTION_TYPE";
export const UPDATE_PASSWORD_ACTION_TYPE = "UPDATE_PASSWORD_ACTION_TYPE";
export const GET_LOGIN_PASS_ACTION_TYPE = "GET_LOGIN_PASS_ACTION_TYPE";
// export const FILL_LIST_ACTION_TYPE = "FILL_LIST_ACTION_TYPE";
// // forget login password
export const FORGET_PASSWORD_ACTION_TYPE = "FORGET_PASSWORD_ACTION_TYPE";
export const VERIFY_OTP_ACTION_TYPE = "VERIFY_OTP_ACTION_TYPE";
export const FORGET_GET_OTP_ACTION_TYPE = "FORGET_GET_OTP_ACTION_TYPE";
export const FORGET_UPDATE_PASSWORD_ACTION_TYPE = "FORGET_UPDATE_PASSWORD_ACTION_TYPE";

// Registration Receipt
export const RECEIPT_ENTRY_ACTION_TYPE = "RECEIPT_ENTRY_ACTION_TYPE";
export const RECEIPT_LIST_ACTION_TYPE = "RECEIPT_LIST_ACTION_TYPE";
export const PERFORMA_INVOICE_ACTION_TYPE = "PERFORMA_INVOICE_ACTION_TYPE";
export const RECEIPT_DETAILS_ACTION_TYPE = "RECEIPT_LIST_ACTION_TYPE";
export const RECEIPT_GENERATE_VOUCHER_ACTION_TYPE = "RECEIPT_GENERATE_VOUCHER_ACTION_TYPE";
export const SHARE_EMAIL_ACTION_TYPE = "SHARE_EMAIL_ACTION_TYPE";
export const RECEIPT_NUMBER_ACTION_TYPE = "RECEIPT_NUMBER_ACTION_TYPE";
export const GET_EMAIL_ACTION_TYPE = "GET_EMAIL_ACTION_TYPE";
export const RECEIPT_DEL_ACTION_TYPE = "RECEIPT_DEL_ACTION_TYPE";
export const RECEIPT_UPDATE_ACTION_TYPE = "RECEIPT_UPDATE_ACTION_TYPE";
export const PENDING_RECEIPT_DETAILS_ACTION_TYPE = "PENDING_RECEIPT_DETAILS_ACTION_TYPE"
export const GET_RECEIPT_PDF_ACTION_TYPE = "GET_RECEIPT_PDF_ACTION_TYPE"
export const RECEIPT_SHARE_ACTION_TYPE = "RECEIPT_SHARE_ACTION_TYPE"
export const GET_REFUND_PDF_ACTION_TYPE = "GET_REFUND_PDF_ACTION_TYPE"

export const SEND_PAYMENT_FORM = "SEND_PAYMENT_FORM"

export const GET_CART_LIST = "GET_CART_LIST"
//promo code
export const GET_PROMO_CODE_LIST_ACTION_TYPE = "GET_PROMO_CODE_LIST";
export const GET_PROMO_CODE_DETAILS_ACTION_TYPE = "GET_PROMO_CODE_DETAILS";
export const INSERT_PROMO_CODE_ACTION_TYPE = "INSERT_PROMO_CODE";
export const UPDATE_PROMO_CODE_ACTION_TYPE = "UPDATE_PROMO_CODE";
export const DELETE_PROMO_CODE_ACTION_TYPE = "DELETE_PROMO_CODE";

// Blog
export const GET_BLOG_LIST_ACTION_TYPE = "GET_BLOG_LIST_ACTION_TYPE";
export const GET_BLOG_DETAILS_ACTION_TYPE = "GET_BLOG_DETAILS_ACTION_TYPE";
export const INSERT_UPDATE_BLOG_ACTION_TYPE = "INSERT_UPDATE_BLOG_ACTION_TYPE";
export const DELETE_BLOG_ACTION_TYPE = "DELETE_BLOG_ACTION_TYPE";

// Master
export const GET_MASTER_LIST_ACTION_TYPE = "GET_MASTER_LIST_ACTION_TYPE";
export const GET_MASTER_DETAILS_ACTION_TYPE = "GET_MASTER_DETAILS_ACTION_TYPE";
export const INSERT_UPDATE_MASTER_ACTION_TYPE = "INSERT_UPDATE_MASTER_ACTION_TYPE";
export const DELETE_MASTER_ACTION_TYPE = "DELETE_MASTER_ACTION_TYPE";

//event
export const GET_EVENT_LIST_ACTION_TYPE = "GET_EVENT_LIST_ACTION_TYPE";
export const GET_EVENT_DETAILS_ACTION_TYPE = "GET_EVENT_DETAILS_ACTION_TYPE";
export const INSERT_UPDATE_EVENT_ACTION_TYPE = "INSERT_UPDATE_EVENT_ACTION_TYPE";
export const DELETE_EVENT_ACTION_TYPE = "DELETE_EVENT_ACTION_TYPE";

//event enquiry
export const GET_EVENT_ENQUIRY_LIST_ACTION_TYPE = "GET_EVENT_ENQUIRY_LIST_ACTION_TYPE";
export const GET_EVENT_ENQUIRY_DETAILS_ACTION_TYPE = "GET_EVENT_ENQUIRY_DETAILS_ACTION_TYPE";
export const INSERT_UPDATE_EVENT_ENQUIRY_ACTION_TYPE = "INSERT_UPDATE_EVENT_ENQUIRY_ACTION_TYPE";
export const DELETE_EVENT_ENQUIRY_ACTION_TYPE = "DELETE_EVENT_ENQUIRY_ACTION_TYPE";

//user
export const GET_MEMBER_DASHBOARD_CARDS_ACTION_TYPE = "GET_MEMBER_DASHBOARD_CARDS_ACTION_TYPE";

// action ID name
export const countryActionId = "1";
export const stateActionId = "2";
export const cityActionId = "3";
export const pincodeActionId = "4";
export const industryActionId = "5";
export const businessSectorActionId = "6";
export const primaryServicesActionId = "7";
export const exportMarketsActionId = "8";
export const documentsListActionId = "9";
export const gstValidationListActionId = "10";
export const receiptVoucherTypeActionId = "11";
export const memberActionId = "12";
export const bankActionId = "13";
export const paymentModeActionId = "14";
export const receiptAccountTypeActionId = "15";
export const tradeServiceTypeActionId = "16";
export const organisationTypeActionId = "17";
export const enterpriseTypeActionId = "18";
export const moduleActionId = "19";
export const eventActionId = "20";
export const platformActionId = "21";
export const serviceActionId = "22";
export const grantActionId = "23";
export const enableActionId = "24";
export const statusActionId = "25";
export const pgViewChargesActionId = "28";


export const appVersion = '1.0.0';
export const buildNumber = '20220511';
export const NA = 'NA';

export const passErr = 'Please enter password'



export const sort = (list, tableValue, isSort) => {
  isSort = !isSort
  if (!isSort) {
    // sorting
    var sort = list.sort((a, b) => {
      const nameA = tableValue.toUpperCase(); // ignore upper and lowercase
      const nameB = tableValue.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    // this.setState({list : sort})
    var data = [sort, !sort]
    return data;
  }
  else {
    // reverse
    var sort = list.sort((a, b) => {
      const nameA = tableValue.toUpperCase(); // ignore upper and lowercase
      const nameB = tableValue.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return 1;
      }
      if (nameA > nameB) {
        return -1;
      }
      return 0;
    });
    // this.setState({list : sort})
    var data = [sort, !sort]
    return data;
  }
  // this.setState({isToDateSort : !isToDateSort})
}

export const toastError = (msg) => {
  toast.error(msg, {
    theme: 'colored',
    autoClose: 3000,
    hideProgressBar: true,
  })
}

export const toastSuccess = (msg) => {
  toast.success(msg, {
    theme: 'colored',
    autoClose: 1000,
    hideProgressBar: true,
  })
}

export function timeout(delay) {
  return new Promise(res => setTimeout(res, delay));
}

